import React from "react";
import { Link } from "react-router-dom";
import { FaUsers, FaLinkedinIn, FaEnvelope } from "react-icons/fa";

const OurPeoplePage = () => {
  const teamMembers = [1, 2, 3, 4, 5, 6];

  return (
    <div className="relative bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] min-h-screen overflow-hidden">
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#1298b5]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
      <div className="absolute bottom-20 right-10 w-72 h-72 bg-[#f97316]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="text-center mb-10 animate-fadeInDown">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#1298b5] to-[#0b819b] rounded-2xl text-white mb-4 shadow-lg">
            <FaUsers className="text-2xl" />
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold text-[#073b4c] mb-3">
            Our <span className="text-[#1298b5]">People</span>
          </h1>

          <div className="w-20 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto rounded-full mb-4"></div>

          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Meet the dedicated team behind Aabharan Foundation – the heart that
            drives our mission.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 animate-fadeInUp">
          {teamMembers.map((i) => (
            <div
              key={i}
              className="group bg-white/90 backdrop-blur-sm rounded-3xl shadow-lg p-6 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-[#d8f4f8] hover:border-[#1298b5]/50"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-22 h-22 bg-[#eafaff] rounded-full flex items-center justify-center text-4xl text-[#1298b5] mb-4 border-4 border-white shadow-lg group-hover:bg-[#1298b5] group-hover:text-white transition-all duration-300">
                  👤
                </div>

                <h3 className="text-lg font-bold text-[#073b4c]">
                  Team Member {i}
                </h3>

                <p className="text-[#1298b5] text-sm font-semibold mb-3">
                  Position
                </p>

                <div className="flex gap-3 mt-1">
                  <a
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-[#eafaff] text-[#1298b5] hover:bg-[#1298b5] hover:text-white transition"
                  >
                    <FaLinkedinIn size={14} />
                  </a>

                  <a
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-[#eafaff] text-[#1298b5] hover:bg-[#f97316] hover:text-white transition"
                  >
                    <FaEnvelope size={14} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <p className="text-gray-600 text-sm mb-4">
            Want to join our team? Check out our{" "}
            <Link
              to="/career"
              className="text-[#1298b5] font-bold hover:text-[#f97316] hover:underline"
            >
              Careers page
            </Link>
            .
          </p>

          <Link
            to="/career"
            className="inline-flex bg-gradient-to-r from-[#1298b5] to-[#0b819b] hover:from-[#f97316] hover:to-[#fb923c] text-white px-7 py-3 rounded-full font-semibold text-sm shadow-lg hover:shadow-xl transition-all duration-300"
          >
            View Openings
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.08); }
          66% { transform: translate(-20px, 20px) scale(0.95); }
          100% { transform: translate(0px, 0px) scale(1); }
        }

        .animate-blob {
          animation: blob 7s infinite;
        }

        .animation-delay-2000 {
          animation-delay: 2s;
        }

        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInDown {
          animation: fadeInDown 0.8s ease-out forwards;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default OurPeoplePage;